<template>
  <Layout>
    <detail :fullList="fullList"></detail>
  </Layout>
</template>

<script>
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import detail from "../home/detail"


var apiKey = '6dc99789-2448-4f11-9bfa-e6600366c6cb'
var siteId = '2139'
var channelId = '2150'
export default {
  components: {
    detail
  },
  data() {
    return {
      fullList: [],
      detail: {
        addDate: '',
        summary: '',
        content: ''
      }
    };
	},
	created() {
    // 获取菜单列表
    axios.get(requestUrls.siteserverUrl + `/api/v1/stl/channels?apiKey=${apiKey}&siteId=2139&channelIndex=Abp`).then(
      res => {
        let data = res.data.value
        data.forEach((li,index) => {
          this.fullList.push({title: li.channelName})
          if (li.childrenCount == 0) {   // 无二级栏目
            axios.post(requestUrls.siteserverUrl + `/api/v1/contents?apiKey=${apiKey}`, {
                siteId: siteId,
                channelId: li.id,
                orders: 'addDate DESC'
            }).then(res => {
              this.detail = res.data.contents[0]
              this.$set(this.fullList[index],'expand', true)
              this.$set(this.fullList[index],'children',res.data.contents)
            })
          } else {   // 二级栏目
            this.$set(this.fullList[index],'children',[])
            axios.get(requestUrls.siteserverUrl + `/api/v1/stl/channels?apiKey=${apiKey}&siteId=2139&channelIndex=${li.indexName}`).then(
              res => { 
                res.data.value.forEach((child,i) => {
                  this.fullList[index].children.push({title: child.channelName})
                  axios.post(requestUrls.siteserverUrl + `/api/v1/contents?apiKey=${apiKey}`, {
                      siteId: siteId,
                      channelId: child.id,
                      orders: 'addDate DESC'
                  }).then(res => {
                    this.$set(this.fullList[index],'expand',true)
                    this.$set(this.fullList[index].children[i],'children',res.data.contents)
                  })
                })
              }
            )
          }
        })
      }
    )
	},
};
</script>

<style lang="less" scoped>
.ivu-layout {
  height: 100%;
  &:first-child {
    border: 1px solid #e9eaec;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
